module.exports = __webpack_public_path__ + "img/739de0e.png";